import { joinDataTestId } from "@/constants/data-test-ids.utils";

const component = "subscription-empty-state-card";

export const subscriptionEmptyStateCardDataTestIds = {
  component,
  createSubscriptionCta: joinDataTestId(component, "create-subscription-cta"),
};
